import styled from 'styled-components';

import { BORDER_RADIUS, media } from '@belong/themes';

import { Copy } from '../../styles/Typography/Copy';

export const Container = styled.div<{
  isCentered: boolean;
  backgroundColor?: string;
  hasSmallIcon?: boolean;
}>`
  display: flex;
  align-items: ${props => (props.isCentered ? 'center' : 'start')};
  ${props =>
    props.backgroundColor
      ? `
      background: ${props.backgroundColor};
      border-radius: ${BORDER_RADIUS.CARD};
      padding: 1.6rem;
    `
      : ''};
  justify-content: space-between;

  ${media('xs')`
    ${props => (props.hasSmallIcon ? 'flex-direction: column; align-items: flex-start;' : '')};
  `}
  ${media('sm')`
    flex-direction: row;
    align-items: center;
  `}
`;
export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1 1 auto;
  text-align: left;

  > ${Copy} {
    margin-top: 0.8rem;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  text-align: right;
  justify-content: flex-end;

  ${media('xs')`
    text-align: left;
  `}
  ${media('sm')`
    text-align: right;
  `}
  ${media('md')`
    margin-left: 4.8rem;
  `}
`;

export const Heading = styled(Copy)<{ hasSmallIcon?: boolean }>`
  ${props => (props.hasSmallIcon ? 'margin-top: 0.4rem;' : 'margin-top: 0 !important;')};
  flex: 1 0 60%;
`;

export const SmallIconWrapper = styled.div<{ beginsWithIcon: boolean }>`
  display: flex;
  align-items: center;
  text-align: left;
  justify-content: flex-end;
  ${props => (props.beginsWithIcon ? 'flex-direction: row' : 'flex-direction: row-reverse')};
`;
